import Box from 'assets/components/box/Box';
import Button from 'assets/components/button/Button';
import ThemeButtonCircle from 'assets/components/button/themes/Theme.Button.Circle';
import DataMap from 'assets/components/dataMap/DataMap';
import Icon from 'assets/components/icon/Icon';
import Page from 'assets/components/page/Page';
import ThemePageError from 'assets/components/page/themes/Theme.Page.Error';
import ThemeTableSimple from 'assets/components/table/themes/Theme.Table.Simple';
import ThemeTagRounded from 'assets/components/tag/themes/Theme.Tag.Rounded';
import { getLocales } from 'assets/locales/Locale';
import { useAuthStore } from 'assets/providers/authStore/Provider.AuthStore';
import Theme from 'assets/themes/Theme.Common';
import { DistributorAction, useDistributorProvider } from '../Distributor.Hooks';
import ThemeWrapperStack from 'assets/themes/wrappers/Theme.Wrapper.Stack';

export default function DistributorList() {
  const { lang } = getLocales();
  const { listApi, pageRouter } = useDistributorProvider();
  const { permissions } = useAuthStore();

  return !listApi.payload && !listApi.isExecuting && listApi.apiCounter > 0 ? (
    <Page
      class={ThemePageError}
      sidebar={<Icon class="fas-clipboard-list" />}
      header={lang.distributors}
      render={lang.noInfo}
    />
  ) : (
    <table className={ThemeTableSimple}>
      <thead>
        <tr>
          <th></th>
          <th>{lang.name}</th>
          <th data-actions>{lang.actions}</th>
        </tr>
      </thead>
      <tbody>
        <DataMap
          data={listApi.payload?.data}
          render={({ data: distributor }) => (
            <tr key={distributor.id}>
              <td width="1%">
                {distributor?.isInactive ? (
                  <Box
                    class={ThemeTagRounded}
                    style={{ color: Theme.Color.error, backgroundColor: Theme.Color.errorLight }}
                  >
                    <Icon class="fas-ban" />
                    &nbsp;{lang.inactive}
                  </Box>
                ) : (
                  <Box
                    class={ThemeTagRounded}
                    style={{ color: Theme.Color.success, backgroundColor: Theme.Color.successLight }}
                  >
                    <Icon class="fas-check" />
                    &nbsp;{lang.active}
                  </Box>
                )}
              </td>
              <td>
                <b>{distributor.name}</b>
              </td>
              <td>
                <Box class={ThemeWrapperStack}>
                  <Button
                    onClick={pageRouter.updateParams}
                    data={{
                      id: distributor.id.toString(),
                      action: DistributorAction.EDIT,
                    }}
                    disabled={!permissions.EDIT_DISTRIBUTOR}
                    active
                    class={ThemeButtonCircle}
                    media={<Icon class="fas-edit" />}
                    htmlElementProps={{ title: lang.edit }}
                  />
                  <Button
                    onClick={pageRouter.updateParams}
                    data={{
                      id: distributor.id.toString(),
                      action: DistributorAction.DELETE,
                    }}
                    disabled={!permissions.DELETE_DISTRIBUTOR}
                    active
                    class={ThemeButtonCircle}
                    media={<Icon class="fas-trash" />}
                    htmlElementProps={{ title: lang.delete }}
                  />
                </Box>
              </td>
            </tr>
          )}
        />
      </tbody>
    </table>
  );
}
